import { routes as ListCourses } from './list_courses/index.js'
import { routes as CreateCourses } from './create/index.js'

export default [
  {
    path: 'cursos',
    component: () => import('./Courses.vue'),
    meta: {
      pageSection: 'Cursos',
      pageTitle: 'Lista',
      requiresAuth: true,
      is_teacher: false,
    },
    children: [...ListCourses, ...CreateCourses],
  },
]
